import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectAuthData } from "../store/redux/slices/Auth-slice";
import useNetworkStatus from "../../hooks/useNetworkStatus";
import { getDataFromDB } from "../../db/dbHelpers";
import { getAccessToken, decodeToken } from "../../apis/tokenManager";

const SET_PASSWORD_PATH = "/set-password";

const AuthGuard = ({ children }) => {
  const authData = useSelector(selectAuthData);
  const location = useLocation();
  const [offlineData, setOfflineData] = useState(null);
  const { isOnline } = useNetworkStatus();

  useEffect(() => {
    if (!isOnline) {
      const fetchOfflineData = async () => {
        const data = await getDataFromDB("credentials");
        if (data) {
          setOfflineData(data);
        }
      };
      fetchOfflineData();
    }
  }, [isOnline]);

  const isAuthenticated = isOnline
    ? authData?.isAuthenticated
    : offlineData?.isAuthenticated;

  if (isOnline && decodeToken(getAccessToken())?.must_change_password) {
    return location.pathname.startsWith(SET_PASSWORD_PATH) ? (
      <>{children}</>
    ) : (
      <Navigate to={`${SET_PASSWORD_PATH}?forced=1`} replace />
    );
  }

  if (!isAuthenticated && isOnline) {
    return <Navigate to="/auth/login" />;
  }

  return <>{children}</>;
};

export default AuthGuard;
